// extracted by css-extract-rspack-plugin
export default {"datePickerButton":"wya8V5","skeleton":"YsI1nW","container":"QY5AtV","clearButton":"iKW6Y8","calendar":"I5el0h"};